import { FC } from 'react';
import { ChartDelta } from '../../Chart/NetWorthChart/ChartDelta';
import { DateFilterDropdown } from '../../Chart/NetWorthChart/DateFilterDropdown';

import { Chart } from './Chart';
import { useAccountChart } from '../hooks/useAccountChart';
import { useMediaQuery } from '@mui/material';
import { SMTailwindMinPixelBreakpointWidth } from '../../util';

export interface AccountChartInnerProps {
  groupID: string;
  householdID: string;
}

export const AccountChartInner: FC<AccountChartInnerProps> = ({ groupID, householdID }) => {
  const { delta, transformedData } = useAccountChart(groupID, householdID);
  const isSmall = useMediaQuery(`(max-width: ${SMTailwindMinPixelBreakpointWidth}px)`);

  return (
    <div>
      <ChartDelta delta={delta} />
      <DateFilterDropdown />
      <Chart
        className="mt-2"
        barMinHeight={20}
        barWidth={isSmall ? `${(window.innerWidth - 72) / 30}px` : '20.28px'}
        data={transformedData}
      />
    </div>
  );
};
